import _classCallCheck from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import Effect from "./Effect";

var Chorus =
/*#__PURE__*/
function (_Effect) {
  _inherits(Chorus, _Effect);

  function Chorus() {
    var _this;

    _classCallCheck(this, Chorus);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Chorus).call(this));
    _this.name = "chorus";
    return _this;
  }

  return Chorus;
}(Effect);

export { Chorus as default };